// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const livingsRoutes = [
  route('create', '/create', Create, meta('Adicionar Morador', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Morador', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Moradores', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/livings', livingsRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/livings/routes.js